import script from "./address.vue?vue&type=script&lang=ts&setup=true"
export * from "./address.vue?vue&type=script&lang=ts&setup=true"

import "./address.vue?vue&type=style&index=0&id=6af9aaa5&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af9aaa5"]])

export default __exports__